import { v4 as uuidv4 } from 'uuid';

export type B3TraceContext = Readonly<{
  traceId: string;
  spanId: string;
}>;

export const createB3TraceContext = (): B3TraceContext => {
  const traceId = uuidv4().replaceAll('-', '');

  return {
    traceId,
    spanId: traceId.slice(-16)
  };
};
